import { Inject, Injectable } from "@angular/core";
import { DwDataRequest, DwDatasource, DwMetaDataService, DwMetaDataServiceToken, DwOrmDataService, DwOrmDataServiceToken, DwOrmDataSource, DwQuery, DwSecurityUserService } from "@devwareapps/devware-cap";
import { AppMetaData, AppMetaDataItemNames } from "../../../meta-data/app-meta-data.service";

@DwDatasource({
    keyName: 'CourseLessonProgressAssignmentDataSource',
    display: 'Course Lesson Progress Assignment Data Source',
    itemName: AppMetaDataItemNames.CourseLessonProgress,
})
@Injectable()
export class CourseLessonProgressAssignmentDataSourceService extends DwOrmDataSource {

    constructor(
        @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        @Inject(DwMetaDataServiceToken) metaDataService: DwMetaDataService,
        private securityUserService: DwSecurityUserService,
    ) {
        super(dwOrmDataService, metaDataService, AppMetaDataItemNames.CourseModule);
    }

    initDataSource() {

    }

    prepareRequestQuery(request: DwDataRequest): DwQuery {
        const baseQuery = super.prepareRequestQuery(request);

        const newQuery = AppMetaData.Queries.StudentLesssonProgressNoCount.CreateQueryBuilderFromQuery(baseQuery);

        newQuery.addOrderBy(o => o.CourseModuleModuleOrder);
        newQuery.addOrderBy(o => o.CourseLessonLessonOrder);

        return newQuery.query;
    }

}